import { openPdf } from 'utils';
import { getPdf } from './report';

export const viewAnalytics = async () =>
  await getPdf('telerik-reports/view-analytics')
    .then(openPdf)
    .catch(() => {});
